import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Permissive reader for tests/<id>/auteur/execution.json — the v4 authoring
 * payload kane-cli embeds in the pack. Worker-portable (no React, no data/ui
 * imports). Same posture as run.yaml parsing: guard every hop, ignore unknown
 * keys, and return null rather than throw — a broken execution.json degrades
 * the steps tree to the result.yaml flat list, never the whole detail view.
 *
 * Shape (observed, contract still settling backend-side):
 *   { instructions: [ { content_type: 'generative_block', objective, status,
 *       children: [ { content_type: 'instruction', instruction, command,
 *         status: 'success'|'failed', reasoning, error_message,
 *         operations: [{ operation_id, error_message, x_coord, y_coord }] } ]
 *   } ], start_timestamp, end_timestamp, status }
 *
 * Nested containers (branches[].children, module_content) are flattened into
 * their block's leaf list — the viewer renders one level of grouping.
 */

function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}
var asString = function asString(v) {
  return typeof v === 'string' && v !== '' ? v : null;
};
var asFiniteNumber = function asFiniteNumber(v) {
  return typeof v === 'number' && Number.isFinite(v) ? v : null;
};

/** One if/else branch, structured for the rich card (kaneai
 * ConditionalBlockV4 port). */

/** Loose stringification for operand values (numbers author as numbers). */
var asOperand = function asOperand(v) {
  return typeof v === 'string' && v !== '' ? v : typeof v === 'number' || typeof v === 'boolean' ? String(v) : null;
};
function toAssertion(op) {
  var _asOperand, _asOperand2;
  if (!op) return null;
  var tree = asRecord(op.expression_tree);
  var checks = tree ? Array.isArray(tree.sub_results) && tree.sub_results.length > 0 ? tree.sub_results : Array.isArray(tree.sub_checks) ? tree.sub_checks : [] : [];
  var sub = asRecord(checks[0]);
  var passed = typeof op.assertion_status === 'boolean' ? op.assertion_status : op.assertion_status === 'pass' ? true : sub && typeof sub.passed === 'boolean' ? sub.passed : null;
  if (!sub && passed === null) return null;
  return {
    passed: passed,
    extracted: sub ? (_asOperand = asOperand(sub.extracted_value)) !== null && _asOperand !== void 0 ? _asOperand : asOperand(sub.store_key) : null,
    expected: sub ? (_asOperand2 = asOperand(sub.expected_value)) !== null && _asOperand2 !== void 0 ? _asOperand2 : asOperand(sub.expected) : null,
    operator: sub ? asString(sub.operator) : null
  };
}

/** api leaves: content_type 'api' / command 'API'; the sealed api_data
 * (node-level, or operations[0]) carries the request + response. */
function toApi(node, op) {
  var _asString, _asRecord, _ref;
  var ct = asString(node.content_type);
  var cmd = ((_asString = asString(node.command)) !== null && _asString !== void 0 ? _asString : '').toLowerCase();
  if (ct !== 'api' && cmd !== 'api') return null;
  var data = (_asRecord = asRecord(node.api_data)) !== null && _asRecord !== void 0 ? _asRecord : op ? asRecord(op.api_data) : null;
  var request = data ? asRecord(data.request) : null;
  var response = data ? asRecord(data.response) : null;
  return {
    method: (_ref = request ? asString(request.method) : null) !== null && _ref !== void 0 ? _ref : 'GET',
    url: request ? asString(request.url) : null,
    responseStatus: response ? asFiniteNumber(response.status) : null,
    responseTimeMs: response ? asFiniteNumber(response.time) : null,
    request: request,
    response: response
  };
}
function toLeaf(node) {
  var _asString2;
  var ops = Array.isArray(node.operations) ? node.operations : [];
  var op = asRecord(ops[0]);
  var x = op ? asFiniteNumber(op.x_coord) : null;
  var y = op ? asFiniteNumber(op.y_coord) : null;
  var command = asString(node.command);
  return {
    instructionId: asString(node.instruction_id),
    instruction: asString(node.instruction),
    command: command,
    status: asString(node.status),
    reasoning: asString(node.reasoning),
    intent: op ? asString(op.intent) : null,
    operationId: op ? asString(op.operation_id) : null,
    errorMessage: (_asString2 = asString(node.error_message)) !== null && _asString2 !== void 0 ? _asString2 : op ? asString(op.error_message) : null,
    cursor: x !== null && y !== null ? {
      x: x,
      y: y
    } : null,
    assertion: command && command.toLowerCase() === 'assertion' ? toAssertion(op) : null,
    api: toApi(node, op)
  };
}
function toIfBranch(br, index) {
  var _asOperand3, _asOperand4;
  var condition = asString(br.condition);
  var checks = Array.isArray(br.sub_checks) ? br.sub_checks : [];
  var sub = asRecord(checks[0]);
  var leaves = [];
  if (Array.isArray(br.children)) {
    var _iterator = _createForOfIteratorHelper(br.children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        var c = asRecord(child);
        if (c) collectLeaves(c, leaves);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    label: index === 0 ? 'If' : condition !== null ? 'Else If' : 'Else',
    condition: condition,
    passed: typeof br.passed === 'boolean' ? br.passed : null,
    subCheck: sub ? {
      left: (_asOperand3 = asOperand(sub.extracted_value)) !== null && _asOperand3 !== void 0 ? _asOperand3 : asOperand(sub.store_key),
      operator: asString(sub.operator),
      right: (_asOperand4 = asOperand(sub.expected)) !== null && _asOperand4 !== void 0 ? _asOperand4 : asOperand(sub.expected_value)
    } : null,
    leaves: leaves
  };
}

/** Depth-first leaf collection across every container shape the format has
 * grown so far. conditional_block / until_block become CONTAINER leaves —
 * one leaf carrying its nested leaves as a structured payload (the rich
 * if/else + until cards) instead of silently flattening/dropping them. */
function collectLeaves(node, out) {
  var ct = asString(node.content_type);
  if (ct === 'conditional_block') {
    var branches = Array.isArray(node.branches) ? node.branches : [];
    var leaf = toLeaf(node);
    leaf.ifElse = {
      resolvedBranchIndex: typeof node.resolved_branch_index === 'number' ? node.resolved_branch_index : null,
      branches: branches.map(function (b, i) {
        var br = asRecord(b);
        return br ? toIfBranch(br, i) : null;
      }).filter(function (b) {
        return b !== null;
      })
    };
    out.push(leaf);
    return;
  }
  if (ct === 'until_block') {
    var nested = [];
    if (Array.isArray(node.children)) {
      var _iterator2 = _createForOfIteratorHelper(node.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          var c = asRecord(child);
          if (c) collectLeaves(c, nested);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    var _leaf = toLeaf(node);
    _leaf.until = {
      label: asString(node.block_label),
      condition: asString(node.condition),
      conditionMet: typeof node.condition_met === 'boolean' ? node.condition_met : null,
      currentCount: asFiniteNumber(node.current_count),
      maxRetries: asFiniteNumber(node.max_retries),
      leaves: nested
    };
    out.push(_leaf);
    return;
  }
  if (ct === 'instruction' || asString(node.instruction)) {
    out.push(toLeaf(node));
    return;
  }
  var containers = [];
  if (Array.isArray(node.children)) containers.push.apply(containers, _toConsumableArray(node.children));
  if (Array.isArray(node.branches)) {
    var _iterator3 = _createForOfIteratorHelper(node.branches),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var b = _step3.value;
        var br = asRecord(b);
        if (br && Array.isArray(br.children)) containers.push.apply(containers, _toConsumableArray(br.children));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  if (Array.isArray(node.module_content)) containers.push.apply(containers, _toConsumableArray(node.module_content));
  for (var _i = 0, _containers = containers; _i < _containers.length; _i++) {
    var _child = _containers[_i];
    var _c = asRecord(_child);
    if (_c) collectLeaves(_c, out);
  }
}

/**
 * Parse execution.json text. Null on anything that isn't a readable
 * instructions payload; blocks with zero recognizable leaves survive
 * (their objective still renders).
 */
export function parseExecution(text) {
  var doc;
  try {
    doc = asRecord(JSON.parse(text));
  } catch (_unused) {
    return null;
  }
  if (!doc || !Array.isArray(doc.instructions)) return null;
  var blocks = [];
  doc.instructions.forEach(function (raw, i) {
    var _ref2, _asString3, _asString4;
    var node = asRecord(raw);
    if (!node) return;
    var leaves = [];
    collectLeaves(node, leaves);
    var isLeafItself = leaves.length === 1 && leaves[0].instructionId === asString(node.instruction_id);
    blocks.push({
      key: (_ref2 = (_asString3 = asString(node.generative_id)) !== null && _asString3 !== void 0 ? _asString3 : asString(node.instruction_id)) !== null && _ref2 !== void 0 ? _ref2 : "block-".concat(i),
      // A bare top-level instruction becomes its own single-leaf group.
      contentType: isLeafItself ? 'flat' : (_asString4 = asString(node.content_type)) !== null && _asString4 !== void 0 ? _asString4 : 'generative_block',
      objective: isLeafItself ? null : asString(node.objective),
      status: asString(node.status),
      leaves: leaves
    });
  });
  return {
    status: asString(doc.status),
    startTimestamp: asString(doc.start_timestamp),
    endTimestamp: asString(doc.end_timestamp),
    blocks: blocks
  };
}